<template>
  <div class="slide" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'red_overlay',
  data() {
    return {
      parallax: [
        {
          start: 7600,
          end: 8000,
          fromStyle: { opacity: '0' },
          toStyle: { opacity: '0.7' },
          easing: 'linear'
        },
        {
          start: 9100,
          end: 9600,
          fromStyle: { opacity: '0.7' },
          toStyle: { opacity: '0' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  transition: 0.2s;
  z-index: 3;
  background-color: #911a1c;
  mix-blend-mode: color-burn;
  pointer-events: none;
}
</style>
